(function ($) {

    $.fn.modal = function () {

        var elem = $(this),
            triggers = elem.find('.js-modal__trigger');

        const init = function () {

                triggers.off('click').on('click', function (event) {

                    var trigger = $(this),
                        target = $(trigger.attr('href'));

                    if (!target) {

                        return;

                    }

                    event.preventDefault();

                    // Add Redirect URL to login & registration forms in modal-user-access.php
                    $('#modal_login input[name="access_redirect"]').val(trigger.data('access_redirect'));

                    if (target.hasClass('is-active')) {

                        modalClose(target);

                    } else {

                        modalOpen(target);

                    }

                });

                $('body').on('click', '.modal__background:not(.modal__container)', function () {

                    var target = $(this).parent();

                    if (target.hasClass('is-active')) {

                        modalClose(target);

                    }

                })


            },
            modalOpen = function (target) {

                var scrollPosition = $(window).scrollTop();

                target.css('top', scrollPosition).fadeIn(300, function () {

                    target.addClass('is-active');

                    $(window).disablescroll({
                        handleKeys: false
                    });

                    // Focus search input on activation
                    $('.search-form__input').focus();

                });

            },
            modalClose = function (target) {

                target.fadeOut(300, function () {

                    target.removeClass('is-active');
                    $(window).disablescroll('undo');

                    /*if(target.attr('data-destroy') == 'true'){

                        target.remove();

                    }*/

                });

            };

        init();

        return {
            init: init,
            modalOpen: modalOpen
        };

    }

}(jQuery));